import React from 'react';
import designTokens from '@/design-tokens';

interface ProductProps {
  size?: number | string;
  color?: string;
  strokeWidth?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

export const Product: React.FC<ProductProps> = ({
  size = designTokens['icon/size/default'] || 24,
  color = designTokens['icon/primary'] || '#343A40',
  strokeWidth = 2,
  className,
  style
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M22 7L12 2L2 7M22 7V17L12 22M22 7L12 12M2 7V17L12 22M2 7L12 12M12 22V12M17 4.5L7 9.5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Product;
